/* import __COLOCATED_TEMPLATE__ from './confirm-delete-modal.hbs'; */
import templateOnly from '@ember/component/template-only';

interface ConfirmDeleteModalSignature {
  Args: {
    deleteButtonText?: string;
    isLoading?: boolean;
    onCancel?: () => void;
    onDelete?: () => void;
    name?: string;
    title?: string;
  };
  Blocks: {
    default: [];
  };
}

const ConfirmDeleteModalComponent = templateOnly<ConfirmDeleteModalSignature>('ConfirmDeleteModal');

export default ConfirmDeleteModalComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ConfirmDeleteModal: typeof ConfirmDeleteModalComponent;
    'confirm-delete-modal': typeof ConfirmDeleteModalComponent;
  }
}
